<template>
  <div class="top-hero2">
    <div class="container">
      <div id="challange-target">hidden</div>

      <div class="marginTop bg-gray-100 ">
        <!-- stats dashboard -->
        <dashboardstats
          :stats="pendingMessages"
          :tags="tags"
          :messages="messages"
        >
        </dashboardstats>

        <div class="p-4 flex justify-center items-center">
          <div class="relative">
            <div class="absolute top-4 left-3">
              <i
                class="fa fa-search text-gray-400 z-20 hover:text-gray-500"
              ></i>
            </div>
            <form>
              <input
                type="search"
                v-model="searchMessage"
                class="bg-white text-gray-700 h-14 sm:w-96 pl-10 pr-20 rounded-lg border z-0 focus:shadow focus:outline-none"
                placeholder="Search messages..."
              />
              <div class="absolute top-2 right-2">
                <button
                  type="submit"
                  class="h-10 w-20 text-white rounded-lg bg-indigo-600 hover:bg-indigo-700"
                >
                  Search
                </button>
              </div>
            </form>
          </div>
        </div>

        <div
          v-if="filterMessages"
          class="max-w-3xl mx-auto px-4 sm:px-6 lg:max-w-7xl sm:py-6 lg:px-8"
        >
          <ul
            role="list"
            class="grid grid-cols-1 gap-5 sm:gap-6 sm:grid-cols-2 lg:grid-cols-4"
          >
            <li
              v-for="result in filterMessages"
              :key="result.id"
              class="flex shadow-sm rounded-md"
            >
              <div
                @click="redirect(result)"
                class="cursor-pointer flex-1 flex items-center justify-between border bg-white rounded-md truncate hover:shadow-xl"
              >
                <div class="flex-1 px-4 py-2 text-sm truncate">
                  <a class="text-gray-900 font-medium hover:text-gray-600">{{
                    result.message_name
                  }}</a>
                  <p class="text-gray-500">
                    <span
                      v-if="result.message_type == 1"
                      class="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-green-100 text-green-800"
                    >
                      sms
                    </span>
                    <span
                      v-else
                      class="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-blue-100 text-blue-800"
                    >
                      email
                    </span>
                  </p>
                </div>
              </div>
            </li>
          </ul>
        </div>

        <!-- cards content -->
        <maincontent
          :tags="tags"
          :contacts="contacts"
          :messages="messages"
          @displayMessageModal="createMessage"
          @displayContactModal="createContact"
          @refreshContacts="getContacts()"
          @refreshTags="getTags()"
        ></maincontent>
      </div>

      <!-- Modal -->
      <!-- This example requires Tailwind CSS v2.0+ -->
      <div class="fixed z-10  inset-0 overflow-y-auto" v-if="isOpen">
        <div
          class="flex items-end justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0"
        >
          <div class="fixed inset-0 transition-opacity" aria-hidden="true">
            <div class="absolute inset-0 bg-gray-500 opacity-75"></div>
          </div>

          <!-- This element is to trick the browser into centering the modal contents. -->
          <span
            class="hidden sm:inline-block sm:align-middle sm:h-screen"
            aria-hidden="true"
            >&#8203;</span
          >

          <div
            class="md:text-left h-full w-full inline-block bg-white rounded-lg text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle sm:max-w-lg sm:w-full"
            role="dialog"
            aria-modal="true"
            aria-labelledby="modal-headline"
          >
            <div class="px-4 pt-5 pb-4 sm:p-6 sm:pb-4">
              <h3
                class="text-lg leading-6 font-medium text-gray-900"
                id="modal-headline"
              >
                Add New Contact
              </h3>
              <div class="mt-2">
                <p class="text-sm text-gray-500">
                  Contacts are assigned to multiples tags and messages
                </p>

                <v-form @submit.prevent="createCRM()">
                  <div class="container">
                    <div class="form-group">
                      <label for="name">Contact Name:</label>
                      <input
                        type="text"
                        v-model="name"
                        class="form-control"
                        aria-describedby="nameHelp"
                        placeholder="Contact Name"
                      />
                    </div>

                    <div class="form-group">
                      <label for="name">Phone:</label>
                      <input
                        type="text"
                        v-model="phone"
                        class="form-control"
                        aria-describedby="nameHelp"
                        placeholder="Phone"
                      />
                    </div>

                    <div class="form-group">
                      <label for="name">Email:</label>
                      <input
                        type="text"
                        v-model="email"
                        class="form-control"
                        aria-describedby="nameHelp"
                        placeholder="Email"
                      />
                    </div>

                    <!--
                      Extra Credit - how many combinations of contact lists can be created? (combinations with repetition) https://www.mathsisfun.com/combinatorics/combinations-permutations.html
                      Phase Two - Unit testing of each combination for accuracy and efficiency
                      -->
                    <div class="form-group">
                      <label for="name">Assign tag (Optional)</label>
                      <multiselect
                        v-model="tagsSelected"
                        :options="tags"
                        :multiple="true"
                        :close-on-select="true"
                        :clear-on-select="true"
                        :preserve-search="true"
                        placeholder="Add Tag"
                        label="name"
                        track-by="id"
                        :preselect-first="false"
                      >
                      </multiselect>
                    </div>

                    <div
                      class="bg-gray-50 px-4 py-3 sm:px-6 sm:flex sm:flex-row-reverse"
                    >
                      <button
                        :disabled="name === '' || phone === '' || email === ''"
                        type="submit"
                        class="disabled:opacity-50 mt-3 w-full inline-flex justify-center rounded-md border border-gray-300 shadow-sm px-4 py-2 bg-primary text-white font-medium hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 sm:mt-0 sm:ml-3 sm:w-auto sm:text-sm"
                      >
                        Save
                      </button>
                      <button
                        @click="isOpen = false"
                        type="button"
                        class="mt-3 w-full inline-flex justify-center rounded-md border border-gray-300 shadow-sm px-4 py-2 bg-white text-base font-medium text-gray-700 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 sm:mt-0 sm:ml-3 sm:w-auto sm:text-sm"
                      >
                        Cancel
                      </button>
                    </div>
                  </div>
                </v-form>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- close Modal -->

      <!-- Modal -->
      <!-- This example requires Tailwind CSS v2.0+ -->
      <div class="fixed z-10  inset-0 overflow-y-auto" v-if="isOpenMessage">
        <div
          class="flex items-end justify-center pt-4 px-4 pb-20 text-center sm:block sm:p-0"
        >
          <div class="fixed inset-0 transition-opacity" aria-hidden="true">
            <div class="absolute inset-0 bg-gray-500 opacity-75"></div>
          </div>

          <!-- This element is to trick the browser into centering the modal contents. -->
          <span
            class="hidden sm:inline-block sm:align-middle sm:h-screen"
            aria-hidden="true"
            >&#8203;</span
          >

          <div
            class="md:text-left h-full w-full inline-block bg-white rounded-lg text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle sm:max-w-lg sm:w-full"
            role="dialog"
            aria-modal="true"
            aria-labelledby="modal-headline"
          >
            <div class="px-2 pt-2 sm:p-6 sm:pb-4">
              <!-- This example requires Tailwind CSS v2.0+ -->
              <div class="bg-gray-50 overflow-hidden py-2">
                <div class="relative px-2 sm:px-6 lg:px-8">
                  <div class="text-center">
                    <h3 class="text-base uppercase font-medium text-yellow-800">
                      Important Note!
                    </h3>
                    <div class="text-sm text-yellow-700">
                      <p>
                        The message has a default type (email) if you want to
                        change to SMS please enable the following toggle option
                      </p>
                      <div class="-mt-4 flex justify-center align-center">
                        <v-switch
                          v-model="smsType"
                          inset
                          color="orange darken-3"
                        ></v-switch>
                        <span
                          class="text-gray-800 -ml-2 text-base text-orange-700"
                          >SMS</span
                        >
                      </div>
                    </div>
                  </div>

                  <!-- <div class="lg:grid lg:grid-cols-2 lg:gap-8 lg:items-center"> -->

                  <div
                    v-if="smsType === false"
                    class="sm:px-2 sm:py-2 bg-white shadow sm:rounded-md"
                  >
                    <v-text-field
                      label="Message Name"
                      outlined
                      v-model="messageName"
                    ></v-text-field>

                    <!-- <div class="-mt-8 flex align-center">
                                  <v-checkbox
                                    v-model="messageRepeated"
                                  ></v-checkbox> 
                                <span class="text-gray-800 -ml-2 text-sm text-gray-400">Repeating message?</span>
                              </div> -->

                    <div class="relative bg-gray-900">
                      <div class="absolute inset-0">
                        <img
                          class="h-full w-full object-cover"
                          src="https://homesby360.s3.amazonaws.com/b5.jpeg"
                          alt=""
                        />
                        <div
                          class="absolute inset-0 bg-gray-500 mix-blend-multiply"
                          aria-hidden="true"
                        ></div>
                      </div>
                      <div class="relative max-w-7xl mx-auto py-4 px-4">
                        <h1
                          class="text-2xl font-extrabold tracking-tight text-white sm:text-4xl text-center"
                        >
                          360 Real Estate
                        </h1>

                        <blockquote>
                          <div
                            class="mt-2 relative text-center text-base font-medium text-gray-100 md:flex-grow"
                          >
                            Is a full service brokerage firm able to buy, sell,
                            or rent and manage residential and commercial
                            properties.
                          </div>
                        </blockquote>
                      </div>
                    </div>

                    <div class="p-2">
                      <v-form @submit.prevent="createCrmMessage()">
                        <div class="form-group">
                          <p class="text-base block text-gray-500">
                            Hello USERNAME,
                          </p>
                          <textarea
                            type="text"
                            class="form-control"
                            rows="5"
                            aria-describedby="nameHelp"
                            placeholder="Message"
                            v-model="messageBody"
                          >
                          </textarea>

                          <blockquote
                            class="mt-1 py-4 bg-gray-100 md:flex-grow md:flex md:flex-col"
                          >
                            <div
                              class="relative text-center text-xs font-medium text-gray-600 md:flex-grow"
                            >
                              This EMAIL was sent to you because we want to
                              <br />provide information you might need.<br />
                            </div>
                          </blockquote>
                        </div>

                        <div class="bg-gray-50 px-4 py-3 sm:px-6 flex gap-2">
                          <button
                            :disabled="messageBody === ''"
                            type="submit"
                            class="disabled:opacity-50 mt-3 w-full inline-flex justify-center rounded-md border border-gray-300 shadow-sm px-4 py-2 bg-primary text-white font-medium hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 sm:mt-0 sm:ml-3 sm:w-auto sm:text-sm"
                          >
                            Save
                          </button>

                          <button
                            @click="isOpenMessage = false"
                            type="button"
                            class="mt-3 w-full inline-flex justify-center rounded-md border border-gray-300 shadow-sm px-4 py-2 bg-white text-base font-medium text-gray-700 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 sm:mt-0 sm:ml-3 sm:w-auto sm:text-sm"
                          >
                            Cancel
                          </button>
                        </div>
                      </v-form>
                    </div>
                  </div>

                  <div
                    v-else
                    class="rounded-md sm:px-2 sm:py-2 bg-white shadow overflow-hidden"
                  >
                    <div class="mt-2">
                      <div class="p-2">
                        <v-form @submit.prevent="createCrmMessage()">
                          <div class="form-group">
                            <p class="text-base block text-gray-500">
                              Hello USERNAME,
                            </p>

                            <v-textarea
                              counter="100"
                              solo
                              rows="5"
                              aria-describedby="nameHelp"
                              placeholder="Message"
                              v-model="messageBody"
                            ></v-textarea>
                          </div>

                          <div class="bg-gray-50 px-4 py-3 sm:px-6 flex gap-2">
                            <button
                              :disabled="messageBody === ''"
                              type="submit"
                              class="disabled:opacity-50 mt-3 w-full inline-flex justify-center rounded-md border border-gray-300 shadow-sm px-4 py-2 bg-primary text-white font-medium hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 sm:mt-0 sm:ml-3 sm:w-auto sm:text-sm"
                            >
                              Save
                            </button>

                            <button
                              @click="isOpenMessage = false"
                              type="button"
                              class="mt-3 w-full inline-flex justify-center rounded-md border border-gray-300 shadow-sm px-4 py-2 bg-white text-base font-medium text-gray-700 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 sm:mt-0 sm:ml-3 sm:w-auto sm:text-sm"
                            >
                              Cancel
                            </button>
                          </div>
                        </v-form>
                      </div>
                    </div>
                  </div>

                  <!-- </div> -->
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- close Modal -->
    </div>
  </div>
</template>
<script
  src="https://code.jquery.com/jquery-3.5.1.slim.min.js"
  integrity="sha384-DfXdz2htPH0lsSSs5nCTpuj/zy4C+OGpamoFVy38MVBnE+IbbVYUew+OrCXaRkfj"
  crossorigin="anonymous"
></script>
<script>
import Multiselect from "vue-multiselect";
import Contactmodal from "./Modals/CreateContactModal";
import Messagemodal from "./Modals/MessageModal";
import Tagmodal from "./Modals/TagModal";
import Dashboardstats from "./crm/dashboardStats.vue";
import Maincontent from "./crm/MainContent.vue";

import Swal from "sweetalert2";

export default {
  components: {
    Multiselect,
    Contactmodal,
    Messagemodal,
    Tagmodal,
    Dashboardstats,
    Maincontent
  },

  data() {
    return {
      url: "https://ui-avatars.com/api/?name=",
      rest: "&background=5564eb&color=fff",
      numberFilter: 8,

      smsType: false,
      showReceipt: false,

      contacts: [],
      messages: [],
      tags: [],
      options: {},
      tagsSelected: [],

      messageName: "",
      messageBody: "",
      messageDelivery: "",

      name: "",
      email: "",
      phone: "",
      dialog: false,
      message: {},
      tagUsers: "",
      displayUsers: false,
      isOpen: false,
      isOpenMessage: false,
      messageSelected: "",
      checkProfile: false,
      userProfile: "",
      search: "",
      pendingMessages: 0,
      messageRepeated: false,
      searchMessage: ""
    };
  },

  computed: {
    filterDocs() {
      return this.docs.map(element => {
        return element.name;
      });
    },

    userFilter() {
      if (this.search == "") {
        return this.contacts;
      } else {
        return this.contacts.filter(user => {
          return (
            user.name.toLowerCase().includes(this.search.toLowerCase()) ||
            user.email.toLowerCase().includes(this.search.toLowerCase())
          );
        });
      }
    },

    filterMessages() {
      if (this.searchMessage == "") {
        return;
      } else {
        return this.messages.filter(item => {
          return item.message_name
            .toLowerCase()
            .includes(this.searchMessage.toLowerCase());
        });
      }
    }

    //     filterMessages() {
    //     if (this.searchMessage == "") {
    //         return this.messages
    //     } else {
    //         let allMessages = this.messages.filter(item => {
    //             return item.message_name.toLowerCase().includes(this.searchMessage.toLowerCase());
    //         });

    //         let users = this.contacts.filter(item => {
    //             return item.name.toLowerCase().includes(this.searchMessage.toLowerCase()) || item.phone.toLowerCase().includes(this.searchMessage.toLowerCase());
    //         });
    //         return allMessages.push(users);

    //     }
    // }
  },

  created() {
    this.getContacts();
    this.getMessages();
    this.getTags();
  },

  methods: {
    redirect(message) {
      this.$router.push({ name: "CrmMessage", params: { id: message.id } });
    },

    seeAllUsers() {
      this.$router.push({ name: "listings" });
    },

    getContacts() {
      window.axios.get("/api/crm").then(response => {
        this.contacts = response.data;
      });
    },

    getMessages() {
      window.axios.get("/api/message_all").then(response => {
        this.messages = response.data[0];
        this.pendingMessages = response.data[1];
      });
    },

    getTags() {
      window.axios.get("/api/crmTags").then(response => {
        this.tags = response.data;
      });
    },

    createCRM() {
      let tag = new FormData();

      $.each(this.tagsSelected, function(key, value) {
        tag.append(`tagIds[${key}]`, value.id);
      });

      tag.append("name", this.name);
      tag.append("email", this.email);
      tag.append("phone", this.phone);

      window.axios.post("/api/crm", tag).then(res => {
        if (res.data === "exists") {
          Swal.fire({
            icon: "error",
            title: "Duplicate Email",
            text:
              "This email is already register as a contact please try another"
          });
        } else {
          this.isOpen = false;
          this.name = "";
          this.email = "";
          this.phone = "";
          this.tagsSelected = [];
          Swal.fire({
            position: "top-end",
            icon: "success",
            title: "Contact succesfully created",
            showConfirmButton: false,
            timer: 1500
          });
        }

        this.getContacts();
      });
    },

    createCrmMessage() {
      let crmMessage = new FormData();

      //  $.each(this.tagsSelected, function(key, value) {
      //      crmMessage.append(`tagIds[${key}]`, value.id);
      //  });

      crmMessage.append("messageName", this.messageName);
      crmMessage.append("messageBody", this.messageBody);
      crmMessage.append("type", this.smsType);
      // crmMessage.append("messageDelivery", this.picker2);
      crmMessage.append("messageRepeated", this.messageRepeated);

      window.axios.post("/api/crm_message", crmMessage).then(res => {
        this.isOpenMessage = false;

        Swal.fire({
          title: "Message succesfully created!",
          showDenyButton: true,
          showCancelButton: true,
          confirmButtonText: `Add Tags and Deliver date`,
          denyButtonText: `Continue creating messages`
        }).then(result => {
          /* Read more about isConfirmed, isDenied below */
          if (result.isConfirmed) {
            this.$router.push({ name: "CrmMessage", params: { id: res.data } });
            // Swal.fire('Saved!', '', 'success')
          } else if (result.isDenied) {
            this.getMessages();
          }
        });

        // this.getMessages();
      });
    },

    openModal(item) {
      this.singleGroup = item;
      $("#selectForms").modal("show");
    },

    openDocument2(doc) {
      //  this.dialog = !this.dialog
      this.singleDoc = doc;
    },

    // toggleTags(valuec) {
    //   this.tagsSelected = valuec.id
    // }

    openMessage(item) {
      this.message = item;
      this.dialog = true;
    },

    openUsers(users) {
      this.tagUsers = users;
      this.displayUsers = true;
    },

    closeUsers() {
      this.tagUsers = "";
      this.displayUsers = false;
    },

    createContact() {
      this.isOpen = true;
    },

    createMessage() {
      this.isOpenMessage = true;
    },

    checkUser(user) {
      this.checkProfile = true;
      this.userProfile = user;
    },

    closeCheckUser() {
      this.checkProfile = false;
      this.userProfile = "";
    },

    updateUser() {
      this.checkProfile = false;
      this.getContacts();
    },

    searchByFilter(tag) {
      this.contacts = tag.users;
    }
  }
};
</script>
